import moment from 'moment'
import { useIntl } from 'react-intl'
import { CardBorderColor, CardMode } from '@models/card'
import { LabelSize, LabelType } from '@models/label'
import { ActivityProps, ActivityModule, ProjectStatus } from '@models/activities'
import { commonFunctions } from '@Techedge/digitalportal-shared'
import { dateFormat } from '@utils/localization/intlHelper'
import Card from '@components/UI/Card/Card'
import Label from '@components/UI/Label/Label'
import { useEffect, useState } from 'react'
import { formatDateLocale, formatDateTZ } from '@/app/utils/commonFunctions'

const getLabelType = (status: ProjectStatus) => {
    switch (status) {
        case ProjectStatus.NEW:
            return LabelType.VIOLET_LIGHT
        case ProjectStatus.RELEASED:
            return LabelType.BLUE_LIGHT
        case ProjectStatus.REJECTED:
            return LabelType.ERROR_LIGHT
        case ProjectStatus.READ:
            return LabelType.DARK_BLUE_LIGHT
        case ProjectStatus.IN_PROGRESS:
            return LabelType.WARNING_LIGHT
        case ProjectStatus.PRE_CLOSED:
            return LabelType.DARK_GREEN_LIGHT
        case ProjectStatus.IN_APPROVAL:
            return LabelType.DARKEST_BLUE_LIGHT
        case ProjectStatus.REDO:
            return LabelType.YELLOW_LIGHT
        case ProjectStatus.CLOSED:
            return LabelType.GREEN_LIGHT
        case ProjectStatus.OVERDUE:
            return LabelType.SALMON_LIGHT
        case ProjectStatus.CANCELLED:
            return LabelType.ERROR_LIGHT
        case ProjectStatus.TO_BE_RELEASED:
            return LabelType.WARNING_LIGHT
        case ProjectStatus.DRAFT:
            return LabelType.WARNING_LIGHT
        default:
            LabelType.BLUE_LIGHT
    }
}

const getCardBorderColor = (module: ActivityModule) => {
    switch (module) {
        case ActivityModule.COMMUNICATION:
            return CardBorderColor.LIGHT_YELLOW
        case ActivityModule.VISIT:
            return CardBorderColor.LIGHT_GREEN
        case ActivityModule.SVT:
            return CardBorderColor.LIGHT_GREEN
        case ActivityModule.NEWS:
            return CardBorderColor.LIGHTEST_BLUE
        default:
            return CardBorderColor.LIGHTEST_BLUE
    }
}

const momentHourFormat = 'LT'

const CalendarActivity = (props: Partial<ActivityProps>) => {
    const {
        id,
        title,
        dueTime,
        isMostUrgent,
        sourceModule,
        status,
        time,
        type,
        isRead,
        priority,
        mode,
        hasBorderColor,
        timeZone,
        onClick,
    } = props

    const intl = useIntl()

    const calendarActivityClass = 'home-calendar-activity'

    const [cardProps, setCardProps] = useState({})

    let dateResult: string
    const creationTimeMoment = moment(time)
    const creationTmeFormatted = creationTimeMoment.format(dateFormat)
    const dueTimeMoment = moment(dueTime)
    const dueTimeFormatted = dueTimeMoment.format(dateFormat)
    // dateResult = `${formatDateLocale(creationTmeFormatted)} - ${formatDateLocale(dueTimeFormatted)}`
    dateResult = `${formatDateTZ(time, timeZone)} - ${formatDateTZ(dueTime, timeZone)}`
    const remainingDays = commonFunctions.getRemainingDays(moment(new Date()), dueTimeMoment)
    const diffDate = commonFunctions.getRemainingDays(creationTimeMoment, dueTimeMoment)

    if (!diffDate)
        /*
        dateResult = `${formatDateLocale(creationTmeFormatted)} - ${formatDateLocale(
            dueTimeFormatted
        )}`
        */
        dateResult = `${formatDateTZ(time, timeZone)} - ${formatDateTZ(dueTime, timeZone)}`

    useEffect(() => {
        setCardProps({
            mode: mode || null,
            borderLeftColor: hasBorderColor ? getCardBorderColor(sourceModule) : null,
        })
    }, [])

    return (
        <Card {...cardProps}>
            <div className={calendarActivityClass} onClick={onClick}>
                <div className={`${calendarActivityClass}__header`}>
                    <div className={`${calendarActivityClass}__title-container`}>
                        <div className={`${calendarActivityClass}__type text-mini`}>
                            {intl.formatMessage({
                                id: `home.calendar.activity.type.${type}`,
                                defaultMessage: 'Event generic',
                            })}
                        </div>
                        <div className={`${calendarActivityClass}__dot`}>
                            {/* <span className="text-bold">{` . `}</span> */}
                            <div></div>
                        </div>
                        <div className={`${calendarActivityClass}__module text-mini`}>
                            {intl.formatMessage({
                                id: `${sourceModule}`,
                                defaultMessage: '',
                            })}
                        </div>
                    </div>
                    <div className={`${calendarActivityClass}__status-container`}>
                        {isMostUrgent && (
                            <div className={`${calendarActivityClass}__urgent cu cu-flag-fill`} />
                        )}
                        <div className={`${calendarActivityClass}__status`}>
                            {/* <Label type={getLabelType(status)} size={LabelSize.MICRO}>
                                {intl.formatMessage({
                                    id: `label.status.${status}`,
                                    defaultMessage: status,
                                })}
                            </Label> */}
                        </div>
                    </div>
                </div>
                <div className={`${calendarActivityClass}__title text-bold`}>{title}</div>
                <div className={`${calendarActivityClass}__footer`}>
                    <span className={`${calendarActivityClass}__date text-mini`}>{dateResult}</span>
                    {!!remainingDays && (
                        <span
                            className={`${calendarActivityClass}__date-remaining text-mini ${
                                remainingDays < 7
                                    ? `${calendarActivityClass}__date-remaining--expiring`
                                    : ''
                            }`}>
                            {` (${remainingDays})`}
                        </span>
                    )}
                </div>
            </div>
        </Card>
    )
}

export default CalendarActivity
